import Mars from './mars'

const parseDuration = function (val) {
  let days = (val - (val % (24 * 3600))) / (24 * 3600)
  let hours = (val - days * 24  * 3600 - (val % 3600)) / 3600
  let minutes = (val - days * 24  * 3600 - hours * 3600 - (val % 60)) / 60
  let seconds = val % 60
  let times = []
  if (days) {
    times.push(days + '天')
  }
  if (hours) {
    times.push(hours + ':')
  }
  if (minutes) {
    minutes = (minutes < 10 && times.length ? '0' + minutes : minutes)
    times.push(minutes + ':')
  }
  if (seconds) {
    seconds = (seconds < 10 && times.length ? '0' + seconds : seconds)
    times.push(seconds)
  }
  return times.join('') || '-'
}
export default {
  Mars,
  parseDuration
}
